import React from "react";
import { PublicationsProvider } from "./context/publications-context";
import { PublicationsPage } from "./publications.page";

export function PublicationsFactory() {

    return (
        <PublicationsProvider>
            <PublicationsPage></PublicationsPage>
        </PublicationsProvider>
    );
}